import { SignalRRequest } from '@adreno-common';

export interface TServerRequestPayload {
  hostname: string;
  port: number;
}

export class IBTransferOnlyRequest implements SignalRRequest {
  readonly name = 'IBTransferOnly';
  readonly payload: undefined;
}

export class ResetIBQueuesRequest implements SignalRRequest {
  readonly name = 'ResetIBQueues';
  readonly payload: undefined;
}

export class LoginRequest implements SignalRRequest {
  readonly name = 'Login';
  constructor(public payload: { campaignId: number }) {}
}

export class LoginIBTransferOnlyRequest implements SignalRRequest {
  readonly name = 'LoginIBTransferOnly';
  readonly payload: undefined;
}

export class NailInRequest implements SignalRRequest {
  readonly name = 'NailIn';
  constructor(public payload: TServerRequestPayload) {}
}

export class NailOutAndLogoutRequest implements SignalRRequest {
  readonly name = 'NailOutAndLogout';
  constructor(public payload: TServerRequestPayload) {}
}

export interface CallManualRequestPayload extends TServerRequestPayload {
  callerId: string;
  leadId: string;
  phoneNumber: string;
  timeout: number;
}

export class CallManualRequest implements SignalRRequest {
  readonly name = 'CallManual';
  constructor(public payload: CallManualRequestPayload) {}
}

export class GetAvailableAgentsRequest implements SignalRRequest {
  readonly name = 'GetAvailableAgents';
  readonly payload: undefined;
}

export class GetNextNumberRequest implements SignalRRequest {
  readonly name = 'GetNextNumber';
  constructor(public payload: TServerRequestPayload) {}
}

export class CancelGetNextNumberRequest implements SignalRRequest {
  readonly name = 'CancelGetNextNumber';
  constructor(public payload: TServerRequestPayload) {}
}

export class InboundConnectRequest implements SignalRRequest {
  readonly name = 'InboundConnect';
  constructor(public payload: TServerRequestPayload) {}
}

export class ToggleHoldRequest implements SignalRRequest {
  readonly name = 'ToggleHold';
  constructor(public payload: TServerRequestPayload) {}
}
export class HangUpRequest implements SignalRRequest {
  readonly name = 'HangUp';
  constructor(public payload: TServerRequestPayload) {}
}
export interface TransferToAgentRequestPayload extends TServerRequestPayload {
  agentId: string;
  failoverQueue: string;
  leadId: string;
}

export class TransferToAgentRequest implements SignalRRequest {
  readonly name = 'TransferToAgent';
  constructor(public payload: TransferToAgentRequestPayload) {}
}

export interface Agent3WayRequestPayload extends TServerRequestPayload {
  callerId: string;
  thirdPartyNumber: string;
  timeout: number;
}
export class Agent3WayRequest implements SignalRRequest {
  readonly name = 'Agent3Way';
  constructor(public payload: Agent3WayRequestPayload) {}
}

export interface UnattendedTransferRequestPayload
  extends TServerRequestPayload {
  callerId: string;
  thirdPartyNumber: string;
  timeout: number;
}

export class UnattendedTransferRequest implements SignalRRequest {
  readonly name = 'UnattendedTransfer';
  constructor(public payload: UnattendedTransferRequestPayload) {}
}

export interface AgentRecordingRequestPayload extends TServerRequestPayload {
  filename: string;
}
export class AgentRecordingRequest implements SignalRRequest {
  readonly name = 'AgentRecording';
  constructor(public payload: AgentRecordingRequestPayload) {}
}

export type DiallerSignalRRequests =
  | LoginRequest
  | NailInRequest
  | CallManualRequest
  | GetAvailableAgentsRequest
  | GetNextNumberRequest
  | CancelGetNextNumberRequest
  | InboundConnectRequest
  | ToggleHoldRequest
  | HangUpRequest
  | TransferToAgentRequest
  | Agent3WayRequest
  | UnattendedTransferRequest
  | AgentRecordingRequest
  | IBTransferOnlyRequest
  | LoginIBTransferOnlyRequest
  | ResetIBQueuesRequest
  | NailOutAndLogoutRequest;
